export const SET_LAST_ENTRYID = "SET_LAST_FORMINTERACTION_ENTRYID";


// WEBPACK FOOTER //
// ./components/response-handlers/form-interaction/actions/actionTypes.js